<main [@fadeInOut] id="main-heading" role="main" tabindex="0">
  <div class="col-sm-11 center-block" [@fadeInOut]>
    <div class="row">
      <div class="col-sm-12">
        <h1 tabindex="0" aria-label="Need Help" role="heading" aria-level="1">Need Help?</h1>
        <p tabindex="0" aria-label="Help Desk Contact Information" role="paragraph">
          Please contact our helpdesk at
          <a href="tel:+12156828282" tabindex="0" aria-label="Help Desk Phone Number" role="link">+1 215-682-8282</a>
          (toll free
          <a href="tel:+18778881559" tabindex="0" aria-label="Help Desk Toll Free Phone Number" role="link">+1 877-888-1559)</a>
          or email us anytime at
          <a href="mailto:customer.support@reedtech.com" tabindex="0" aria-label="Help Desk Email Address" role="link">Customer.Support&#64;reedtech.com</a>.
        </p>
        <p class="top-space">
          <a href="../../../assets/documents/reedTechSingleSourceUserGuide.docx" target="_blank" tabindex="0" aria-label="Download User Manual Link" role="link">
            <i class="fas fa-download"></i>
            <span class="icon-text">Download user manual (Word)</span>
          </a>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-10">
        <h1 tabindex="0" aria-label="Need Training" role="heading" aria-level="1">Need Training?</h1>
        <p tabindex="0" aria-label="Training Documentation" role="paragraph">
          Register for SingleSource for Drug Products Training
          <a href="http://go.reedtech.com/edrltraining" target="_blank" tabindex="0" aria-label="Training Documentation Link" role="link">here</a>.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-10">
        <h1 tabindex="0" aria-label="Have Feedback" role="heading" aria-level="1">Have Feedback?</h1>
        <p tabindex="0" aria-label="Feedback Contact Information" role="paragraph">
          Please share your suggestions with the SingleSource team,
          <a href="https://portal.prodpad.com/888c73a4-6d54-11e7-98a7-22000a2145da" target="_blank" tabindex="0" aria-label="Feedback Contact Information Link" role="link">here</a>.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-10">
        <h1 tabindex="0" aria-label="Support Email Address" role="heading" aria-level="1">
          Support for SPL Preparation, SPL Submission and related Labeling Services,emergency and business
          related support:
        </h1>
        <p tabindex="0" aria-label="Support Contact Information" role="paragraph">
          <a href="mailto:spl@reedtech.com"  tabindex="0" aria-label="Support Contact Information Link" role="link">
            <i class="fas fa-envelope"></i>
            <span class="icon-text">spl&#64;reedtech.com</span>
          </a>
        </p>
      </div>
    </div>

    <!--<div class="row">
        <div class="col-sm-10">
            <h1>Primary contact for Structured Product Labeling (SPL) conversion services:</h1>

            <div class="col-sm-12 no-padding">
                <p class="support-subtitle">
                    Support for SPL Preparation, SPL Submission and related Labeling Services
                </p>
                <div class="col-sm-3 support-div  no-padding text-left">
                    <span>Michael Chesla</span><br>
                    <span>Production Manager - Life Sciences</span><br>
                    <span>
                        Reed Tech<span class="support-reg-span">®</span>, a LexisNexis<span
                            class="support-reg-span">®</span> Company
                    </span>
                    <br>
                    <span>| O: (215) 682-8293 | C: (267) 688-0992</span><br>
                    <span><a href="mailto:mchesla@reedtech.com"><i class="fa fa-envelope" aria-hidden="true"></i><span
                                class="icon-text">mchesla@reedtech.com</span></a></span><br>

                </div>
                <div class="col-sm-9 support-div text-left">
                    <span>Rachel Finley</span><br>
                    <span>Supervisor - Life Sciences Services</span><br>
                    <span>Reed Tech<span class="support-reg-span">®</span>, a LexisNexis<span
                            class="support-reg-span">®</span> Company</span><br>
                    <span>| O: (215) 734-2105</span><br>
                    <span><a href="mailto:rfinley@reedtech.com"><i class="fa fa-envelope" aria-hidden="true"></i><span
                                class="icon-text">rfinley@reedtech.com</span></a></span><br>
                </div>
            </div>
        </div>
    </div>-->
    <!--<div class="row">
        <div class="col-sm-10 padding-bottom-60">
            <h1>Life Sciences management contacts:</h1>

            <div class="col-sm-12 no-padding">
                <p class="support-subtitle">
                    Emergency and business related support
                </p>

                <div class="col-sm-3 support-div  no-padding text-left">
                    <span>John Lorenc</span><br>
                    <span>Sr. Manager, Information Solutions - Life Sciences</span><br>
                    <span>Reed Tech<span class="support-reg-span">®</span>, a LexisNexis<span
                            class="support-reg-span">®</span> Company</span><br>
                    <span>| O: (215) 441-6358 | C: (267) 322-1127</span><br>
                    <span><a href="mailto:jlorenc@reedtech.com"><i class="fa fa-envelope" aria-hidden="true"></i><span
                                class="icon-text">jlorenc@reedtech.com</span></a></span>
                </div>

                <div class="col-sm-9 support-div text-left">
                    <span>Jon Nolan</span><br>
                    <span>Associate Product Manager - Life Sciences</span><br>
                    <span>Reed Tech<span class="support-reg-span">®</span>, a LexisNexis<span class="support-reg-span">®</span> Company</span><br>
              <span>| O: (215) 734-2119 | C: (267) 963-8705</span><br>
              <span><a href=" mailto:jnolan@reedtech.com"><i class="fa fa-envelope" aria-hidden="true"></i><span
                                class="icon-text">jnolan@reedtech.com</span></a></span>
                </div>
            </div>
        </div>
    </div>-->
  </div> <!--  End Container -->
</main>
